import { render, staticRenderFns } from "./EntityTable.vue?vue&type=template&id=5d48466e&scoped=true"
import script from "./EntityTable.vue?vue&type=script&lang=js"
export * from "./EntityTable.vue?vue&type=script&lang=js"
import style0 from "./EntityTable.vue?vue&type=style&index=0&id=5d48466e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d48466e",
  null
  
)

export default component.exports